import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { KeycloakUserInfo } from "../../types/User";

export const getKeycloakUserInfo = (
  contactId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["keycloakUserInfo", contactId],
    queryFn: (): Promise<KeycloakUserInfo> => {
      return fetchWithAuth<KeycloakUserInfo>("getKeycloakUserInfo", contactId);
    },
    enabled: isQueryEnabled(options),
  });
};
